import { useState, useRef, useCallback, useEffect } from 'react';
import { EDIT_TIMEOUT_MS } from '../../services/homeLauncher/launcherPersistenceService';

/**
 * Manages edit mode state and auto-exit timeout.
 * Extracted from HomeLauncherPage – behavior is identical.
 */
export default function useLauncherEditMode() {
  const [editMode, setEditMode] = useState(false);
  const [editingIcon, setEditingIcon] = useState(null);
  const editTimeoutRef = useRef(null);

  const resetEditTimeout = useCallback(() => {
    if (!editMode) return;
    if (editTimeoutRef.current) clearTimeout(editTimeoutRef.current);
    editTimeoutRef.current = setTimeout(() => setEditMode(false), EDIT_TIMEOUT_MS);
  }, [editMode]);

  useEffect(() => {
    if (!editMode) {
      if (editTimeoutRef.current) clearTimeout(editTimeoutRef.current);
      return;
    }
    resetEditTimeout();
    return () => {
      if (editTimeoutRef.current) clearTimeout(editTimeoutRef.current);
    };
  }, [editMode, resetEditTimeout]);

  return {
    editMode,
    setEditMode,
    editingIcon,
    setEditingIcon,
    resetEditTimeout,
  };
}
